// Generated by purs version 0.15.14
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Gen_Class from "../Control.Monad.Gen.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_BigInt from "../Data.BigInt/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var add = /* #__PURE__ */ Data_Semiring.add(Data_BigInt.semiringBigInt);
var zero = /* #__PURE__ */ Data_Semiring.zero(Data_BigInt.semiringBigInt);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonNumber);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen);
var sub1 = /* #__PURE__ */ Data_Ring.sub(Data_BigInt.ringBigInt);
var Bytes = function (x) {
    return x;
};
var showBytes = {
    show: function (v) {
        return "(Bytes.fromInt " + (Data_BigInt.toString(v) + ")");
    }
};
var semigroupBytes = {
    append: function (v) {
        return function (v1) {
            return add(v)(v1);
        };
    }
};
var ordBytes = Data_BigInt.ordBigInt;
var monoidBytes = {
    mempty: zero,
    Semigroup0: function () {
        return semigroupBytes;
    }
};
var eqBytes = Data_BigInt.eqBigInt;
var encodeJsonBytes = {
    encodeJson: function (v) {
        return encodeJson(Data_BigInt.toNumber(v));
    }
};
var decodeJsonBytes = {
    decodeJson: function (json) {
        return bind(decodeJson(json))(function (v) {
            return bind(Data_Either.note(new Data_Argonaut_Decode_Error.UnexpectedValue(json))(Data_BigInt.fromNumber(v)))(function (bi) {
                return pure(bi);
            });
        });
    }
};
var arbitraryBytes = {
    arbitrary: /* #__PURE__ */ Control_Bind.bind(Test_QuickCheck_Gen.bindGen)(/* #__PURE__ */ Control_Monad_Gen_Class.chooseFloat(Test_QuickCheck_Gen.monadGenGen)(0.0)(9.007199254740991e15))(function (n1) {
        return pure1(Data_Maybe.fromMaybe(zero)(Data_BigInt.fromNumber(n1)));
    })
};
var toOld = function (v) {
    return v;
};
var toNumber = function (v) {
    return Data_BigInt.toNumber(v);
};
var sub = function (v) {
    return function (v1) {
        return sub1(v)(v1);
    };
};
var fromOld = function (v) {
    return v;
};
var fromInt = function (b) {
    return Data_BigInt.fromInt(b);
};
export {
    fromInt,
    fromOld,
    sub,
    toNumber,
    toOld,
    eqBytes,
    ordBytes,
    semigroupBytes,
    monoidBytes,
    encodeJsonBytes,
    decodeJsonBytes,
    arbitraryBytes,
    showBytes
};
